function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Menu/Iconen/Energized",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "BE_Energized_icon",
  fill: "#425CD4",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L0,30.084466 L30,30.084466 L30,0 L0,0 Z M29.3563107,29.4436893 L0.64368932,29.4436893 L0.64368932,15.4048544 L3.84757282,15.4048544 L3.84757282,14.761165 L0.64368932,14.761165 L0.64368932,0.64368932 L29.3563107,0.64368932 L29.3563107,29.4436893 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.6116505,25.7796117 L20.7378641,12.8533981 L15.9,12.8533981 L17.5398058,4.42718447 L8.67378641,16.2902913 L13.9165049,16.2902913 L12.6116505,25.7796117 Z M9.95533981,15.6495146 L16.3631068,7.0631068 L15.1106796,13.4970874 L19.5669903,13.4970874 L13.6601942,22.9048544 L14.6708738,15.6495146 L9.95533981,15.6495146 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 26.0097087,
  y: 14.7436893,
  width: 3.24757282,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 14.6679612,
  y: 26.0941748,
  width: 1,
  height: 3.24757282
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 14.6504854,
  y: 0.672815534,
  width: 1,
  height: 3.24757282
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(5.906995, 24.056318) rotate(-45.000000) translate(-5.906995, -24.056318) ",
  points: "4.28320811 23.7359298 7.53078093 23.7359298 7.53078093 24.3767065 4.28320811 24.3767065"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(23.971072, 5.992379) rotate(-45.000000) translate(-23.971072, -5.992379) ",
  points: "22.3472858 5.67199047 25.5948586 5.67199047 25.5948586 6.31276716 22.3472858 6.31276716"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(5.845028, 5.975144) rotate(-45.000000) translate(-5.845028, -5.975144) ",
  points: "5.52463943 4.35135801 6.16541613 4.35135801 6.16541613 7.59893083 5.52463943 7.59893083"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(23.906908, 24.041282) rotate(-45.000000) translate(-23.906908, -24.041282) ",
  points: "23.5865193 22.4174952 24.227296 22.4174952 24.227296 25.665068 23.5865193 25.665068"
})));
function SvgEnergyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menu/Iconen/Energized") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyBlue);
export default __webpack_public_path__ + "static/media/Energy_blue.22343d3df4c1c50d1914c10f652295c8.svg";
export { ForwardRef as ReactComponent };